import { useCallback } from "react";
import { Link } from "react-router-dom";
import { getUrlType, openExternalUrl } from "@inbody/core";
const useMenuItemLink = ({
  url,
  target
}) => {
  const isExternal = getUrlType(url) === "external";
  const handleClick = useCallback(() => {
    if (isExternal) {
      openExternalUrl(url);
    }
  }, [url, isExternal]);
  const linkProps = isExternal ? {
    onClick: handleClick
  } : {
    component: Link,
    to: url,
    target: target || "_self"
  };
  return {
    isExternal,
    handleClick,
    linkProps
  };
};
export {
  useMenuItemLink
};
